@if (mediaContent) {
<div class="cs-media-player">
  <!-- <i class="fa fa-times" aria-hidden="true" (click)="closeMedia()"></i> -->
  @if (mediaContent.file_type === 'video') {
  <vg-player>
    <i
      class="fa fa-times vid-close"
      aria-hidden="true"
      (click)="closeMedia()"
    ></i>
    <vg-overlay-play></vg-overlay-play>
    <vg-buffering></vg-buffering>
    <vg-scrub-bar>
      <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
      <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
    </vg-scrub-bar>
    <vg-controls [vgAutohide]="true" [vgAutohideTime]="2">
      <vg-play-pause></vg-play-pause>
      <!-- <vg-scrub-bar style="pointer-events: none;"></vg-scrub-bar> -->
      <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
      <vg-scrub-bar style="pointer-events: none"></vg-scrub-bar>
      <vg-mute></vg-mute>
      <vg-volume></vg-volume>
      <vg-fullscreen></vg-fullscreen>
    </vg-controls>
    <video #media [vgMedia]="media" id="singleVideo" preload="auto" autoplay>
      <source [src]="inputSrc" type="video/mp4" />
    </video>
  </vg-player>
  }
  <!-- <span class="playlist-item has-text-right is-right" style="padding: 5px;background-color: ghostwhite;">
    Questionnaire URL <a class="is-small has-text-right" style="color:darkblue;font-size: 12px;font-weight: 700;background-color: ghostwhite;margin-left: 6px;" href="https://forms.gle/JZwQJACd5TyCg6Ka7" target="_blank">https://forms.gle/JZwQJACd5TyCg6Ka7</a>
  </span> -->
  <!-- <div class="" *ngIf="mediaContent.file_type === 'video'">
  <i class="fa fa-times vid-close" aria-hidden="true" (click)="closeMedia()"></i>
  <video width="400" preload="auto" autoplay controls controlsList="nodownload">
    <source [src]="inputSrc" type="video/mp4">
  </video>
</div> -->
  <!-- <div class="" *ngIf="mediaContent.file_type === 'audio'">
<audio preload="auto" autoplay controls>
  <source [src]="inputSrc" [type]="'audio/mpeg'">
  Your browser does not support the audio element.
</audio>
</div> -->
  @if (mediaContent.file_type === 'audio') {
  <vg-player style="height: 50px; width: 400px">
    <vg-controls>
      <vg-play-pause></vg-play-pause>
      <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
      <vg-scrub-bar>
        <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
        <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
      </vg-scrub-bar>
      <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
      <vg-mute></vg-mute>
      <i
        class="fa fa-times aud-close"
        aria-hidden="true"
        (click)="closeMedia()"
      ></i>
    </vg-controls>
    <audio #audio [vgMedia]="audio" id="myAudio" preload="none" autoplay>
      <source [src]="inputSrc" [type]="'audio/mpeg'" />
    </audio>
  </vg-player>
  }
</div>
}
